export const allExercises = state => state.exercises.all
export const activeExercise = state => state.exercises.active



// WEBPACK FOOTER //
// ./src/vuex/exercises/getters.js